import { AbbreviatedLogoSVG } from '@ev-tech/ui-core-components/Logo';
import { IconButton } from '@ev-tech/ui-core-components/IconButton';
import { Headline } from '@ev-tech/ui-core-components/Headline';
import { CrossNakedIcon } from '@ev-tech/search-modules-shared/Icons';
import { Dialog } from '@base-ui/react/dialog';

import { useChatbotSession } from '../../providers/ChatbotProvider';
import NewChatIcon from '../../assets/NewChat.svg';
import ExpandIcon from '../../assets/Expand.svg';
import CollapseIcon from '../../assets/Collapse.svg';

import styles from './ChatbotHeader.module.css';

type ChatbotHeaderProps = {
  mobile: boolean;
  expanded: boolean;
  onNewChat: () => void;
  onToggleExpanded: () => void;
};

export const ChatbotHeader = ({ mobile, expanded, onNewChat, onToggleExpanded }: ChatbotHeaderProps) => {
  const { t } = useChatbotSession();

  return (
    <header className={styles.header}>
      <span className={styles.logo} aria-hidden="true">
        <AbbreviatedLogoSVG />
      </span>
      <Dialog.Title className={styles.title}>
        <Headline as="span" size="h6" label={t('chatbot.title')} />
      </Dialog.Title>
      <IconButton
        as="button"
        icon={<NewChatIcon aria-hidden="true" />}
        aria-label={t('chatbot.newChat')}
        variant="tertiaryAlt"
        size="xsmall"
        shape="square"
        onClick={onNewChat}
      />
      <span className={styles.divider} aria-hidden="true" />
      {!mobile && (
        <IconButton
          as="button"
          icon={expanded ? <CollapseIcon aria-hidden="true" /> : <ExpandIcon aria-hidden="true" />}
          aria-label={expanded ? t('chatbot.collapse') : t('chatbot.expand')}
          variant="tertiary"
          size="xsmall"
          shape="square"
          onClick={onToggleExpanded}
        />
      )}
      <Dialog.Close
        render={
          <IconButton
            as="button"
            icon={<CrossNakedIcon aria-hidden="true" />}
            aria-label={t('chatbot.close')}
            variant="tertiaryAlt"
            size="xsmall"
            shape="square"
          />
        }
      />
    </header>
  );
};
